import { TwilioError } from "twilio-video";

export type User = {
  id: string;
  username: string;
  password?: string;
  email: string;
  first_name: string;
  last_name: string;
  has_accepted_eula: boolean;
  iat: number;
  createdAt: Date;
  coach?: User;
  privs: number;
};

export enum SessionTiming {
  ACTIVE,
  PAST,
  FUTURE,
  UNKNOWN
}

export enum SessionStatus {
  Scheduled = "Scheduled",
  Cancelled = "Cancelled",
  Completed = "Completed",
  NoShow = "NoShow"
}

export type Session = {
  id: string;
  title: string;
  user: User;
  participants: User[];
  coach: User;
  start_time: Date;
  end_time: Date;
  status: SessionStatus;
};

export type Callback = (...args: any[]) => void;
export type ErrorCallback = (error: TwilioError | Error) => void;
